import { Component, OnInit } from '@angular/core';

import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrl: './permissions.component.scss'
})
export class PermissionsComponent implements OnInit {

  workers: any[] = [];

  permissionColumns: { key: string; title: string }[] = [];

  filter: any = {
    search: '',
    monitors: [],
    groups: [],
  };

  monitors: any = [];
  groups: any = [];

  u = Utils;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {
    this.getWorkers();
  }

  getWorkers(): void {
    const filter = { ...this.filter };
    filter.monitors = filter.monitors.join(',');
    filter.groups = filter.groups.join(',');

    this.okService.loading = true;
    this.okService.get('reports/workerpermissions', filter)
      .subscribe(
        (data) => {
          this.workers = Array.isArray(data.body) ? data.body : [];
          this.refreshPermissionColumns();
          this.groups = this.okService.groups;
          this.monitors = this.okService.monitors;
          this.okService.loading = false;
        },
        () => {
          this.okService.loading = false;
        }
      );
  }

  updateFilter(): void {
    this.getWorkers();
  }

  clearFilter(): void {
    this.filter = {
      search: '',
      monitors: [],
      groups: [],
    };
    this.getWorkers();
  }

  export(): void {
    const fields: any = { ...this.filter, export: true };
    fields.monitors = Array.isArray(fields.monitors) ? fields.monitors.join(',') : '';
    fields.groups = Array.isArray(fields.groups) ? fields.groups.join(',') : '';
    fields.search = fields.search ? fields.search : '';

    this.okService.download('reports/workerpermissions', fields);
  }

  statusBadgeColor(status: string): string {
    switch (status) {
      case 'granted':
        return 'success';
      case 'partial':
        return 'warning';
      case 'denied':
      case 'restricted':
        return 'danger';
      case 'not_determined':
        return 'info';
      case 'unavailable':
        return 'secondary';
      default:
        return 'secondary';
    }
  }

  permissionCell(worker: any, key: string): { status: string; label: string } | null {
    const rows = worker?.rows;
    if (!Array.isArray(rows)) {
      return null;
    }
    const row = rows.find((r: any) => r.key === key);
    if (!row) {
      return null;
    }
    return { status: row.status, label: row.label };
  }

  private refreshPermissionColumns(): void {
    const keyTitles = new Map<string, string>();
    const order = [
      'location_services',
      'location_access',
      'precise_location',
      'location_monitoring',
      'notifications',
      'critical_alerts',
      'background_activity',
      'microphone',
      'motion_fitness',
      'live_activities',
    ];

    for (const worker of this.workers) {
      if (!Array.isArray(worker?.rows)) {
        continue;
      }
      for (const row of worker.rows) {
        if (row?.key && !keyTitles.has(row.key)) {
          keyTitles.set(row.key, row.title ?? row.key);
        }
      }
    }

    const showMotionFitness = this.okService.hasFeature('motion_heartbeat');

    this.permissionColumns = order
      .filter((key) => keyTitles.has(key))
      .filter((key) => showMotionFitness || key !== 'motion_fitness')
      .map((key) => ({ key, title: keyTitles.get(key) as string }));
  }
}
